import { Component } from '@angular/core';

import { CrossReferenceAssessmentsService } from '../../cross-reference-assessments/cross-reference-assessments.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
  AssessmentGridData,
  CrossOpinionEnum,
  CrossReference,
  CrossReferenceOpinionUpdates,
  CrossReferencesOpinionOption,
  CrossVizientOpinionEnum,
  Features,
  User,
} from '../../../../types/types';

export interface VizientAssessmentGridData extends AssessmentGridData {
  user: User;
  productId: number;
  crossReferenceOpinionOptions?: CrossReferencesOpinionOption[];
  features?: Features;
  hasPermissionToAddOpinions: boolean;
}
export interface VizientAssessmentCellRendererParams
  extends ICellRendererParams {
  data: {
    vizientAssessmentGridData?: VizientAssessmentGridData;
  };
  updateVizientAssessment?: (crossReference: CrossReference) => {};
  addNote?: () => {};
}

@Component({
    selector: 'app-grid-vizient-assessment-wrapper',
    templateUrl: './grid-vizient-assessment-wrapper.component.html',
    styleUrls: ['./grid-vizient-assessment-wrapper.component.scss'],
    standalone: false
})
export class GridVizientAssessmentWrapperComponent
  implements ICellRendererAngularComp
{
  vizientAssessmentGridData?: VizientAssessmentGridData;
  crossReference?: CrossReference;
  user?: User;
  params!: VizientAssessmentCellRendererParams;

  get opinion(): CrossVizientOpinionEnum {
    const vizientOpinion = this.crossReference?.gpoOpinion?.opinion;
    if (vizientOpinion === CrossOpinionEnum.DISPUTE)
      return CrossVizientOpinionEnum.DENIED;

    if (vizientOpinion === CrossOpinionEnum.APPROVE)
      return CrossVizientOpinionEnum.APPROVED;

    return CrossVizientOpinionEnum.NO_OPINION;
  }

  constructor(
    private crossReferenceAssessmentsService: CrossReferenceAssessmentsService,
  ) {}

  agInit(params: VizientAssessmentCellRendererParams): void {
    this.params = params;
    this.vizientAssessmentGridData =
      params.data?.vizientAssessmentGridData ||
      params.value?.vizientAssessmentGridData;
    this.crossReference = this.vizientAssessmentGridData?.crossReference;
    this.user = this.vizientAssessmentGridData?.user;
  }

  onAddNote(noteMessage: string) {
    const id = this.crossReferenceAssessmentsService.getCrossReferenceIdForApi(
      this.crossReference,
      this.vizientAssessmentGridData,
    );
    this.crossReferenceAssessmentsService
      .addNote(
        id,
        this.vizientAssessmentGridData!.productId,
        this.crossReference!.toProduct.id,
        noteMessage,
      )
      .subscribe();

    this.crossReference =
      this.crossReferenceAssessmentsService.getUpdatedLocalVizientNotes(
        this.crossReference ?? ({} as CrossReference),
        noteMessage,
        this.vizientAssessmentGridData!.user.emailAddress,
      );
  }

  onUpdateOpinion({
    opinionOptionKey,
    opinionUpdates,
  }: {
    opinionOptionKey: string;
    opinionUpdates: CrossReferenceOpinionUpdates;
  }) {
    const id = this.crossReferenceAssessmentsService.getCrossReferenceIdForApi(
      this.crossReference,
      this.vizientAssessmentGridData,
    );
    this.crossReferenceAssessmentsService
      .updateOpinion(
        id,
        this.vizientAssessmentGridData!.productId,
        this.crossReference!.toProduct.id,
        opinionOptionKey,
      )
      .subscribe();

    this.updateVizientAssessmentData(opinionUpdates);
  }

  private updateVizientAssessmentData(
    opinionUpdates: CrossReferenceOpinionUpdates,
  ) {
    this.crossReference =
      this.crossReferenceAssessmentsService.getUpdatedLocalVizientOpinions(
        this.crossReference ?? ({} as CrossReference),
        opinionUpdates,
        this.vizientAssessmentGridData!.user.organization.id,
      );

    this.crossReference =
      this.crossReferenceAssessmentsService.getUpdatedLocalVizientNotes(
        this.crossReference ?? ({} as CrossReference),
        opinionUpdates.feedbackDescription,
        this.vizientAssessmentGridData!.user.emailAddress,
      );

    if (this.params.updateVizientAssessment) {
      this.params.updateVizientAssessment(this.crossReference!);
    }
  }

  refresh(): boolean {
    return true;
  }
}
